export default "__VITE_ASSET__CUXw6kT6__";